// NavigationBar.js

import React from "react";
import { Button, Divider } from "antd";
import { useNavigate } from "react-router-dom";

const NavigationBar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear(); // Clears the session storage, effectively logging out the user
    navigate("/login"); // Redirects the user to the login page
  };

  const isAuthenticated = () => {
    return sessionStorage.getItem("accessToken") !== null;
  };

  return (
    <div style={{ marginBottom: "20px" }}>
        {/* <Button type="link" onClick={() => navigate("/home")}>Home</Button> */}
        <span style={{ fontSize: "1.5em", paddingRight: "8px" }}>a2z</span>
      {" | "}

      <Button type="link" onClick={() => navigate("/studylist")}>Study List</Button> 
      {/* <Button type="link" onClick={() => navigate("/editor")}>a2z Editor</Button> */}
      {isAuthenticated() && (
        <>
          {" | "}
          <Button type="link" onClick={handleLogout}>Logout</Button>
        </>
      )}
      <Divider/>
    </div>
  );
};

export default NavigationBar;
